export const downloadFromUrl = (url, filename, isTargetBlank = false) => {
	if (url?.length) {
		const link = document.createElement('a')
		link.href = url
		if(filename) {
			link.download = filename
		}
		if (isTargetBlank) {
			link.target = '_blank'
		}
		link.click()
	}
}


function download(url) {
	return new Promise((resolve, reject) => {
		const request = new XMLHttpRequest()
		request.responseType = 'blob'
		request.open('GET', url)
		request.addEventListener('error', reject)
		request.addEventListener('load', () => {
			resolve(request.response)
		})
		request.send()
	})
}

export const downloadFromUrlPromise = async (url, filename) => {
	const blob = await download(url)
	const a = document.createElement('a')
	a.href = URL.createObjectURL(blob)
	a.download = filename
	a.click()
}
